/**
 * @module api/exclusiveApi/exclusiveMitraItemsApi
 */

import secureClient from 'lib/secure-client';
import exclusiveUrl from 'shared_js/helpers/urlHelper/exclusiveUrl';

const PREFIX_URL = `${exclusiveUrl}/mitra-qr/mitra-items`;

/**
 * Retrieve mitra item list
 * https://blueprint.bukalapak.io/exclusive/t/mitra~single~qr~mitra~single~qr~get~exlusive~mitra-qr~mitra-items
 */
function retrieveMitraItems() {
  return this.get(PREFIX_URL, 'user');
}

/**
 * Create mitra item transaction
 * https://blueprint.bukalapak.io/exclusive/t/mitra~single~qr~mitra~single~qr~post~exlusive~mitra-qr~mitra-items~transactions
 */
function createMitraItemTransaction(payload) {
  return this.post(`${PREFIX_URL}/transactions`, 'user', {
    data: payload,
  });
}

/**
 * Retrieve mitra item transaction
 * https://blueprint.bukalapak.io/exclusive/t/mitra~single~qr~mitra~single~qr~get~exlusive~mitra-qr~mitra-items~transactions~mitra~item~id
 */
function retrieveMitraItemTransaction(itemId) {
  return this.get(`${PREFIX_URL}/transactions/${itemId}`, 'user');
}

/**
 * Retrieve mitra items transactions
 */
function retrieveMitraItemTransactions() {
  return this.get(`${PREFIX_URL}/transactions`, 'user');
}

/**
 * Validate voucher code
 */
function validateVoucherCode(params) {
  return this.get(`${PREFIX_URL}/vouchers`, 'user', {
    params: {
      voucher_code: params.voucherCode,
      mitra_item_id: params.mitraItemId,
      schema_id: params.schemaId,
    },
  });
}
/**
 * Collection of exclusive mitra items api
 */

const exclusiveMitraItems = secureClient(
  {
    retrieveMitraItems,
    createMitraItemTransaction,
    retrieveMitraItemTransaction,
    retrieveMitraItemTransactions,
    validateVoucherCode,
  },
  'xhrExclusiveMitraItemsApi',
);

export default exclusiveMitraItems;
